import * as React from 'react';
import { useState, useEffect } from 'react';
import styles from './auditComplete.module.scss';
import successImg from '../static/images_pfizer/assistant/success.png';
import failImg from '../static/images_pfizer/assistant/fail.png';
import searchImg from '../static/images_pfizer/assistant/search.png';
import { ApiCore } from '../api/index';
import { Button } from 'antd-mobile-v5';
const api = new ApiCore();


const AuditComplete = (props: any) => {

    // 1、待处理，2、通过，3、失败
    const [auditState, setAuditState] = useState<any>('');
    const [rejectReason, setRejectReason] = useState<any>('');
    useEffect(() => {
    }, [])

    // 个人信息
    const toComplete = () => {
        props.history.push('/pfizer/personalInfo');
    }

    const initData = () => {
        let registerInfo = sessionStorage.getItem('RegisterGetInfo');
        if (registerInfo) {
            let _info = JSON.parse(registerInfo);
            setAuditState(_info.state);
            setRejectReason(_info.failReasons);
        } 
    }

    return (
        <div className={styles.audit_complete_content}>
            <div className={styles.register_success}>
                    <img src={
                        auditState == 1 ? searchImg : 
                        auditState == 2 ? successImg: 
                        auditState == 3 ? failImg: searchImg
                        } alt="" />
                <div className={styles.txt}>
                    {
                        auditState == 1 ? '等待审核' : 
                        auditState == 2 ? '报名成功': 
                        auditState == 3 ? '审核失败': '等待审核'
                    }
                </div>
                {/* {
                    auditState == 3 &&
                    <>
                        <div className={`${styles.sub_subText} ${styles.reject_reason}`}>
                            {rejectReason}
                        </div>
                        <Button className={styles.btn} color='primary' onClick={ () => { toComplete() } }>去完善信息</Button>
                    </>
                } */}
            </div>
        </div>
    )
}

export default AuditComplete;